// extracted by mini-css-extract-plugin
module.exports = {"Container":"SimpleInput_Container__2h1sC","Label":"SimpleInput_Label__2rP6a","Input":"SimpleInput_Input__3ukBv"};